import { RGBA, TinyColor } from '@ctrl/tinycolor'
import React, { useCallback } from 'react'
import { TooltipIcon } from 'src/editor/shared/icons/tooltip-icon'
import { twJoin } from 'tailwind-merge'

export interface ColorPickerGradientPaletteProps {
  activeGradientIndex: number
  setActiveGradientIndex: (index: number) => void
  gradient: [RGBA, RGBA]
}

export const ColorPickerGradientPalette = ({
  activeGradientIndex,
  setActiveGradientIndex,
  gradient,
}: ColorPickerGradientPaletteProps) => {
  const handleGradientIndexChange = useCallback(
    (index: number) => () => {
      setActiveGradientIndex(index)
    },
    [setActiveGradientIndex],
  )

  return (
    <div className="relative mb-4 h-8 w-full">
      <div className="relative top-1 h-8 w-full overflow-hidden rounded-sm">
        <div
          className="absolute h-8 w-full"
          style={{
            background: `linear-gradient(to right,
              rgba(${gradient[0].r},${gradient[0].g},${gradient[0].b}, ${gradient[0].a}) 0%,
              rgba(${gradient[1].r},${gradient[1].g},${gradient[1].b}, ${gradient[1].a}) 100%)`,
          }}
        />
      </div>
      <button
        type="button"
        className="absolute -top-4 left-0 cursor-pointer"
        onClick={handleGradientIndexChange(0)}
      >
        <TooltipIcon
          className={twJoin(activeGradientIndex === 0 && 'stroke-iconPrimary')}
          style={{ fill: new TinyColor(gradient[0]).toRgbString() }}
        />
      </button>

      <button
        type="button"
        className="absolute -top-4 right-0 cursor-pointer"
        onClick={handleGradientIndexChange(1)}
      >
        <TooltipIcon
          className={twJoin(activeGradientIndex === 1 && 'stroke-iconPrimary')}
          style={{ fill: new TinyColor(gradient[1]).toRgbString() }}
        />
      </button>
    </div>
  )
}
